import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PdfService {

  constructor(private http: HttpClient) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getPdfOffer(offerKey: number): any {
    return this.http.get(`${environment.apiUrl}/Pdf/GetPDFOffer/${offerKey}`, { observe: 'response', responseType: 'blob' });
  }

  getPdfSession(sessionKey: number): any {
    return this.http.get(`${environment.apiUrl}/Pdf/GetPDFSession/${sessionKey}`, { observe: 'response', responseType: 'blob' });
  }

  getPdfBookedSession(bookingKey: number): any {
    return this.http.get(`${environment.apiUrl}/Pdf/GetPDFBookedSession/${bookingKey}`, { observe: 'response', responseType: 'blob' });
  }

  getPdfBasket(userKey: number): any {
    return this.http.get(`${environment.apiUrl}/Pdf/GetPDFBasket/${userKey}`, { observe: 'response', responseType: 'blob' });
  }

}
